function createElement(assetsToBeLoaded) {
  return assetsToBeLoaded.map(({ type, src, defer }) => {
    let element = {};
    return new Promise((resolve) => {
      switch (type) {
        case 'script':
          element = document.createElement('script');
          element.src = src;
          element.type = 'text/javascript';
          element.async = false;
          element.defer = defer;
          element.charset = 'UTF-8';
          element.onload = _elem => resolve(_elem);
          document.body.appendChild(element);
          break;
        case 'link':
          element = document.createElement('link');
          element.href = src;
          element.rel = 'stylesheet';
          element.async = false;
          element.defer = defer;
          element.onload = _elem => resolve(_elem);
          document.head.appendChild(element);
          break;
        default: break;
      }
    });
  });
}

export default async function injectRegistrationScripts() {
  const assetsToBeLoaded = [
    { type: 'link', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlInput.css' },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/InputValidator.js', defer: true },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/tz-moment.js', defer: true },
    { type: 'script', src: '/ca/assets/dest/js/registrationHelper.js?v=40', defer: true },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlTelInputUtils.js' },
  ];

  if (document.getElementById('demo-lead-register')
    && !document.querySelector("script[src='/ca/assets/dest/js/demoRegister.js?v=6']")) {
    assetsToBeLoaded.push({
      type: 'script',
      src: '/ca/assets/dest/js/demoRegister.js?v=6',
      defer: true,
    });
  }

  if (!document.querySelector("script[src='https://storage.googleapis.com/clientaccess/registration/InputValidator.js']")) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}

export async function injectOtherScripts() {
  let assetsToBeLoaded = [];

  if (document.getElementById('js-video-modal') && !document.querySelector("script[src='/ca/assets/dest/js/videoModal.js?v=1']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/ca/assets/dest/js/videoModal.js?v=1', defer: true }]);
  }

  if (document.getElementById('swiper-carousel') && !document.querySelector("script[src='/ca/assets/dest/js/slider.js?v=10']") && !document.querySelector("link[href='https://unpkg.com/swiper/swiper-bundle.min.css']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/ca/assets/dest/js/slider.js?v=10', defer: false }, { type: 'link', src: 'https://unpkg.com/swiper/swiper-bundle.min.css', defer: false }]);
  }

  if (document.getElementById('trustpilot-widget') && !document.querySelector("script[src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', defer: true }]);
  }

  if (document.getElementById('integration-list-wrapper') && !document.querySelector("script[src='/ca/assets/dest/js/integrationRequest.js?v=4']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/ca/assets/dest/js/integrationRequest.js?v=4', defer: true }]);
  }

  if (document.getElementById('card-accordion-parent') && !document.querySelector("script[src='/ca/assets/dest/js/cardAccordion.js?v=1']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/ca/assets/dest/js/cardAccordion.js?v=1', defer: false }]);
  }

  if (assetsToBeLoaded.length > 0) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}
